import { delay } from "@keita/lanepatrol-sdk";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { JobState, JobStatus } from "../models/JobState";

const getJobState = async (jobStateId: string) =>
  await jwtAuthAxios().get<JobState>(`/job-states/${jobStateId}`);

export const JobStateApi = {
  get: getJobState,

  poll: async (
    jobStateId: string,
    intervalMs: number,
    consume: (jobState: JobState) => void
  ) => {
    while (true) {
      await delay(intervalMs);
      const jobState = await getJobState(jobStateId).then(({ data }) => data);
      consume(jobState);
      
      if (
        jobState.status === JobStatus.FAILED ||
        jobState.status === JobStatus.FINISHED
      ) {
        break;
      }
    }
  },
};
